import { render, staticRenderFns } from "./Clearance.vue?vue&type=template&id=0582a93c&scoped=true"
import script from "./Clearance.vue?vue&type=script&lang=js"
export * from "./Clearance.vue?vue&type=script&lang=js"
import style0 from "./Clearance.vue?vue&type=style&index=0&id=0582a93c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0582a93c",
  null
  
)

export default component.exports